"use client";
import { ThemeProvider } from "@/app/theme/ThemeContext";
import { SessionProvider } from "next-auth/react";
import { ReactNode, useEffect } from "react";

export default function ClientProviders({
  children,
  initialTheme = "dark",
}: {
  children: ReactNode;
  initialTheme?: "dark" | "light";
}) {
  useEffect(() => {
    // 注册 Service Worker
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/sw.js')
        .then((registration) => {
          console.log('[PWA] Service Worker registered:', registration);
        })
        .catch((error) => {
          console.error('[PWA] Service Worker registration failed:', error);
        });
    }
  }, []);

  return (
    <SessionProvider>
      <ThemeProvider initialTheme={initialTheme}>{children}</ThemeProvider>
    </SessionProvider>
  );
}
